import client from '../client';

const PATH = '/similar'


/**
 * Create a QMatchProduct with the given QMatchingItems. For more information please
 * read the api middleware docs.
 * @param {Object} payload
 * @param {Object[]} payload.items
 */
function createProduct({ classificationId, items }) {
  return client.post(`${PATH}/qmps`, { classificationId, items }).then(({ data }) => data)
}


/**
 * Create an index with the given body. Please read the docs in the api for more
 * information.
 * @param {Object} body
 */
function createSearcher(body) {
  return client.post(`${PATH}/searchers`, body).then(({ data }) => data);
}


/**
 * Get the brands of the given classification. For more information please visit the docs
 * of the api.
 * @param {Object} params
 */
function getBrands(params) {
  return client.get(`${PATH}/brands`, { params }).then(({ data }) => data)
}


/**
 * Get a page of classifications.
 * For more information please see the middleware docs in the backend.
 * @param {Object} params The parameters for the query.
 */
function getClassifications(params) {
  return client.get(`${PATH}/classifications`, { params }).then(({ data }) => data)
}


/**
 * Get the pivot items using the given params to send in the query.
 * For more information please read the docs in the backend.
 *
 * @param {Object} params to send in the query.
 */
function getPivots(params) {
  return client.get(`${PATH}/pivots`, { params }).then(({ data }) => data)
}


/**
 * Get a QMP using its id.
 * @param {Object} payload
 * @param {Number} payload.id
 */
function getQmp({ id }) {
  return client.get(`${PATH}/qmps/${id}`).then(({ data }) => data)
}


/**
 * Get the qmps with their qmis. For more information please visit the api docs.
 * @param {Object} payload
 * @param {String} payload.brand
 * @param {Number} payload.classificationId
 * @param {Number} [payload.fetch]
 * @param {Number} [payload.offset]
 */
function getQmps({ brand, classificationId, fetch, offset, historyIds, matchingBrands }) {
  return client.get(`${PATH}/qmps`, { params: { brand, classificationId, fetch, offset, historyIds, matchingBrands } }).then(({ data }) => data)
}


/**
 * Get the similar items to the given one.
 * For more information please read the docs in the backend.
 * @param {Object} payload
 */
function getSimilar(params, body) {
  return client.post(`${PATH}/qmis`, { body }, { params }).then(({ data }) => data)
}

function getMatchRanking() {
  return client.get(`/matchRanking`).then(({ data }) => data)
}


/**
 * Remove an item from a QMP.
 * @param {Object} payload
 * @param {Number} payload.qmpId
 * @param {Number} payload.sellerId
 * @param {String} payload.historyId
 */
function removeQmiFromQmp({ qmpId, sellerId, historyId }) {
  return client.delete(`${PATH}/qmps/${qmpId}/qmis`, { params: { sellerId, historyId } })
}


/**
 * Remove an entire QMP from the database. 
 * @param {Object} payload
 * @param {Number} payload.qmpId
 */
function removeQmp({ qmpId }) {
  return client.delete(`${PATH}/qmps/${qmpId}`)
}


export default {
  createSearcher,
  createProduct,
  getBrands,
  getClassifications,
  getPivots,
  getQmp,
  getQmps,
  getSimilar,
  removeQmiFromQmp,
  removeQmp,
  getMatchRanking
}
